import { configureStore, EnhancedStore } from '@reduxjs/toolkit';

import alertsDrawer, { AlertsDrawerState } from './slices/alertsDrawer/alertsDrawer';
import enabledFeatures, { EnabledFeaturesState } from './slices/enabledFeatures/enabledFeatures';
import alerts, { AlertsState } from './slices/alerts/alerts';
import trails, { TrailsState } from './slices/trails/trails';
import areas, { AreasState } from './slices/areas/areas';
import authState, { AuthState } from './slices/authState/authState';
import pendingTrailEdits, { PendingTrailEditsState } from './slices/pendingTrailEdits/pendingTrailEdits';
import search, { SearchState } from './slices/search/search';
import filters, { FiltersState } from './slices/filters';

export type PreloadedState = {
  alertsDrawer: AlertsDrawerState;
  enabledFeatures: EnabledFeaturesState;
  alerts: AlertsState;
  trails: TrailsState;
  areas: AreasState;
  authState: AuthState;
  pendingTrailEdits: PendingTrailEditsState;
  search: SearchState;
  filters: FiltersState;
};

const reducer = {
  alertsDrawer,
  enabledFeatures,
  alerts,
  trails,
  areas,
  authState,
  pendingTrailEdits,
  search,
  filters
};

const buildStore = (preloadedState: PreloadedState): EnhancedStore => configureStore({ reducer, preloadedState });

const store = configureStore({
  reducer
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;

export default buildStore;
